<template>
<div>
<section class="section">
        <div class="container">
          <div class="contact-form" id='contact-form'>
            <h1 class="title is-2 has-text-weight-bold" style="margin-bottom: 10px;">Get Started Today!</h1>
            <h5 class="title is-3 has-text-weight-normal">
              Sign up is easy! Send us your name and email and we’ll take care of the rest.
            </h5>
            <form action="">
              <div class="columns">
                <div class="column is-two-fifths">
                  <div>
                    <div class="columns" style="margin-bottom: 0px;">
                      <div class="column">
                        <div class="field">
                          <div class="control">
                            <input class="input" type="text" placeholder="First">
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <div class="control">
                            <input class="input" type="text" placeholder="Last">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="field">
                        <div class="control">
                          <input class="input" type="text" placeholder="Phone">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-two-fifths">
                  <div class="field">
                    <div class="control">
                      <input class="input" type="email" placeholder="Email">
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input class="input" type="text" placeholder="Hotel Brand">
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div style="width: 100%; height: 100%;">
                      <button class="button is-danger">SUBMIT</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    <section class="section footer" style="border-right: 1px solid black;">
    <div class="container">
      <div class="columns">
        <div class="column">
          <img :src="icons.logo" alt="gi" class="footer-logo image is-5by3 is-paddingless">
          <br><br>
          <span class="has-text-white is-size-7-desktop is-hidden-mobile">
           Copyright &copy; 2018 Guest Impressions, Inc. All rights reserved.  
          </span>
          <!-- <button class="button is-danger">GET STARTED</button> -->
        </div>
        <div class="column">
          <ul class="f-nav">
            <li><a href="">SEE IT IN ACTION</a></li>
            <li><router-link to="/pricing">PRICING</router-link></li>
            <li><a href="/advertise-with-us/" style="color: #ff3e45; font-weight: bold;" target="_blank">ADVERTISE WITH US</a></li>
          </ul>
        </div>
        <div class="column is-two-fifths">
          <p class="has-text-white">Want to learn more? Send us your email to receive more information about our Guest Engagement Solutions.</p>
          <br />
          <div class="field has-addons">
            <div class="control">
              <input class="input newsletter" type="text" placeholder="Enter Email Address" style="background: #fbf8f800; color: #fff;">
            </div>
            <div class="control" style="margin-left: 5px;">
              <a class="button is-danger">
                Submit
              </a>
            </div>
          </div>
        </div>
        <div class="column">
          <p class="has-text-white mb-10">CONTACT US</p>
          <p class="has-text-danger">(619) 722-7117</p>
          <p class="has-text-white mb-10">info@guestimpressions.com</p>

          <p class="has-text-white" >1297 W Main Street Suite E</p>
          <p class="has-text-white mb-10">El Cajon, CA 92116</p>

          <div class="columns is-mobile">
            <div class="column is-1">
              <a href="https://www.facebook.com/conciergo">
                <b-icon pack="fab" icon="facebook-square" size="is-medium" custom-class="has-text-white" > </b-icon>
              </a>
            </div>
            <div class="column is-1 is-offset-1">
              <a href="https://www.linkedin.com/company/conciergo/">
                <b-icon pack="fab" icon="linkedin" size="is-medium" custom-class="has-text-white" > </b-icon>
              </a>
            </div>
          </div>
          <div class="is-hidden-desktop">
            <span class="has-text-white is-size-7-mobile is-hidden-tablet">
             Copyright &copy; 2018 Guest Impressions, Inc. All rights reserved.  
            </span>
          </div>

        </div>
      </div>
    </div>
    </section>
</div>
</template>
<script>
import fbIcon from './../../assets/images/icons/facebook-logo.svg';
import linkedInIcon from './../../assets/images/icons/linkedin-logo.svg';
import logo from './../../assets/images/logo/gi_logo.png';
export default {
  data() {
    return {
      icons: {
        fbIcon,
        linkedInIcon,
        logo
      }
    }
  }
}
</script>
<style scoped lang="scss">
.footer {
  background: #001540;
  padding: 50px 90px 50px 90px;
}
.f-nav {
  margin: 20px 0 0 0;
}
.f-nav > li {
  margin: 10px 0 10px 0;
}
.f-nav > li > a {
  color: #fff;
}
.newsletter::placeholder {
  color: #fff;
}
.social {
  filter: brightness(0) invert(1);
}
a > .social {
  margin-right: 10px;
}
.footer-logo {
  max-height: 5rem;
  filter: brightness(0) invert(1);
}
@media only screen and (max-width: 425px) {
  .social {
    width: 10%;
  }
  .footer {
    padding: 30px;
  }
  .contact-form {
    margin: 30px;
    text-align: center;
    h1 {
      font-size: 35px !important;
    }
    h5 {
      font-size: 20px !important;
    }
  }
}
</style>
